import React, { useState } from 'react';
import SideNavbar from './helpers/SideNavbar';
import { Card, Form, Button } from 'react-bootstrap';
import axios from 'axios';
import Swal from 'sweetalert2';

const ReportIssue = () => {
  const [form, setForm] = useState({
    name: localStorage.getItem('FullName') || '',
    email: localStorage.getItem('Email') || '',
    issueType: 'Scheduling',
    page: '',
    description: ''
  });

  const handleChange = (field, value) => setForm(prev => ({ ...prev, [field]: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log('Submitting issue report:', {
        name: form.name,
        email: form.email,
        issueType: form.issueType,
        pageFeature: form.page,
        message: form.description
      });
      
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/report-issue`, {
        name: form.name,
        email: form.email,
        issueType: form.issueType,
        pageFeature: form.page,
        message: form.description
      });
      
      console.log('Response:', response.data);
      Swal.fire({ icon: 'success', title: 'Report sent!', timer: 2000, showConfirmButton: false });
      setForm(prev => ({ ...prev, page: '', description: '' }));
    } catch (err) {
      console.error('Error submitting issue report:', err);
      console.error('Error response:', err.response?.data);
      Swal.fire({ 
        icon: 'error', 
        title: 'Failed to send', 
        text: err?.response?.data?.message || err.message || 'Try again later.' 
      });
    }
  };

  return (
    <SideNavbar>
      <div className="card shadow-sm p-3 mt-3" style={{ border: 'none', backgroundColor: '#fff' }}>
        <div className="card-header d-flex justify-content-between" style={{ border: 'none', backgroundColor: '#fff' }}>
          <h5 className="welcome-text" style={{ fontSize: '20px', color: '#2e3192', textAlign: 'left' }}>Report an Issue</h5>
        </div>
        <hr />
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Your Name</Form.Label>
              <Form.Control value={form.name} onChange={(e) => handleChange('name', e.target.value)} placeholder="Enter your name" />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Your Email</Form.Label>
              <Form.Control type="email" value={form.email} onChange={(e) => handleChange('email', e.target.value)} placeholder="you@example.com" required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Issue Type</Form.Label>
              <Form.Select value={form.issueType} onChange={(e) => handleChange('issueType', e.target.value)}>
                <option>Scheduling</option>
                <option>Posting</option>
                <option>Authentication</option>
                <option>Payments</option>
                <option>Other</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Page/Feature</Form.Label>
              <Form.Control value={form.page} onChange={(e) => handleChange('page', e.target.value)} placeholder="e.g., Knack Feeds, Schedule Posts" />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control as="textarea" rows={4} value={form.description} onChange={(e) => handleChange('description', e.target.value)} placeholder="Describe the issue with steps to reproduce" required />
            </Form.Group>
            <Button type="submit" style={{ backgroundColor: '#2e3192', borderColor: '#2e3192' }}>Submit</Button>
          </Form>
        </Card.Body>
      </div>
    </SideNavbar>
  );
};

export default ReportIssue;


